export const quickStartPresetGroupsForCommunity: Record<string, string[]> = {
  Workforce: [
    "REPRESENTATION_REPORT",
    "BENCHMARK_REPORT",
    "HIRES_REPORT",
    "PROMOTIONS_REPORT",
    "TERMINATIONS_REPORT",
  ],
  "Talent Acquisition": [
    "APPLICANT_FUNNEL_REPORT",
    "APPLICANT_FUNNEL_CURRENT_REPORT",
    "TIME_TO_FILL_REPORT",
    "JOB_REQUISITION_METRICS_REPORT",
  ],
  "Talent Development": [
    "Performance",
    "Skills",
    "Training",
    "Internal Mobility",
  ],
  "Retention & Risk": [
    "ATTRITION_RATE_REPORT",
    "ATTRITION_PROBABILITY_REPORT",
    "ATTRITION_DRIVERS_REPORT",
    "RETENTION_RATE_REPORT",
  ],
  "Financial Impact": [
    "COMPENSATION_REPORT",
    "COST_OF_ATTRITION_REPORT",
    "Productivity",
    "HR Program ROI",
  ],
  "Talent Experience": [
    "Engagement Scores",
    "Burnout Risk",
    "Sentiment Trends",
    "Manager Effectiveness",
  ],
};

export const disabledPresetsForCommunity: string[] = [
  "Performance",
  "Skills",
  "Training",
  "Internal Mobility",
  "Productivity",
  "HR Program ROI",
  "Engagement Scores",
  "Burnout Risk",
  "Sentiment Trends",
  "Manager Effectiveness",
];
